import { GetReceivers , ConfirmReceiver } from "@/api/AddRecipient";
const state = {
  GetReceivers:{},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  }
};

const actions = {
  GetReceivers({ commit }, params) {
    GetReceivers(params).then(res => {
      try {
        var { data } = res;
        var newData = JSON.parse(
          JSON.stringify(data.data).replace(/label/g, "text")
        );
        commit("SET_DATA", {key:'GetReceivers',data:newData});
      } catch (error) {
        console.log(error)
      }
    });
  },
  ConfirmReceiver({ commit }, params) {
    return new Promise((resolve)=>{
      ConfirmReceiver(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'ConfirmReceiver',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
